import { gql } from '__generated__';

export default gql(`
  mutation CancelScheduledMessage($id: ID!) {
    cancelScheduledMessage(id: $id) {
      ...MessageAttributes
    }
  }
`);
